var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiFire({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29729 1.36142C9.52831 1.42277 9.72186 1.58036 9.82875 1.79415C10.2317 2.60009 10.5325 3.08923 10.835 3.48583C11.1413 3.88726 11.4653 4.2159 11.9581 4.70872C13.097 5.84759 13.6667 7.34192 13.6666 8.83351C13.6666 10.3251 13.097 11.8194 11.9581 12.9583C9.68005 15.2363 5.9866 15.2363 3.70854 12.9583C2.56968 11.8194 2 10.3251 2 8.83351C2 7.34192 2.56967 5.84759 3.70854 4.70872C3.94687 4.47039 4.3053 4.3991 4.6167 4.52808C4.92809 4.65706 5.13113 4.96093 5.13113 5.29798C5.13113 6.23115 5.1894 6.9422 5.46234 7.50935C5.61242 7.82121 5.84654 8.12611 6.25003 8.39819C6.3464 7.51421 6.52292 6.43722 6.76145 5.41497C6.94925 4.61012 7.18282 3.8066 7.46082 3.13654C7.59987 2.8014 7.75712 2.48228 7.9357 2.20675C8.10953 1.93856 8.33287 1.66565 8.62115 1.47346C8.82003 1.34087 9.06627 1.30007 9.29729 1.36142ZM9.60109 12.2679C8.62478 13.2442 7.04187 13.2442 6.06556 12.2679C5.57741 11.7798 5.33333 11.14 5.33333 10.5002C5.33333 10.5002 6.06556 10.9168 7.4167 10.9168C7.4167 10.0835 7.83336 7.58349 8.45836 7.16682C8.87503 8.00015 9.11293 8.24424 9.60109 8.73239C10.0892 9.22054 10.3333 9.86035 10.3333 10.5002C10.3333 11.14 10.0892 11.7798 9.60109 12.2679Z",
    fill: "#252919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiFire);
export default __webpack_public_path__ + "static/media/ai-fire.fc6dcb0c5a82058bd43d1e963d9881ee.svg";
export { ForwardRef as ReactComponent };